import { render, staticRenderFns } from "./label_token.vue?vue&type=template&id=2c655876&"
import script from "./label_token.vue?vue&type=script&lang=js&"
export * from "./label_token.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports